(() => {
  if (!document.body.classList.contains('template-index')) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = window.matchMedia('(max-width: 989px)').matches;

  document.body.classList.add(reduce ? 'ecko-motion-reduce' : 'ecko-luxury-home');
  document.body.classList.toggle('ecko-home-mobile', isMobile);

  if (reduce || isMobile) {
    return;
  }

  // Do not reveal-animate above-the-fold hero text — opacity:0 until JS
  // delays FCP/LCP on mobile Lighthouse runs.
  const revealSelector = [
    '.collection__title',
    '.collection-list__header',
    '.ecko-best-product__heading',
    '.ecko-who-we-are',
    '.ecko-sale__copy',
    '.ecko-testimonials',
    '.image-with-text__content',
    '.image-with-text__media',
    '.ecko-why__intro',
    '.ecko-why__card',
    '.template-index .product-grid .grid__item',
  ].join(', ');

  document.querySelectorAll(revealSelector).forEach((el) => {
    if (el.classList.contains('collection-list__header-text--menu')) return;
    el.classList.add('ecko-reveal');
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px',
    }
  );

  document.querySelectorAll('.ecko-reveal').forEach((el) => observer.observe(el));
})();
